import { useBraze } from '@components/Braze';
import { useEffect, useRef } from 'react';
import { useCompany, useCompanyCanonicalUrl } from '@/hooks/useCompany';

export const BrazeLogLimitModalViewed = () => {
  const { logCustomEvent } = useBraze();
  const isLogged = useRef<boolean>(false);
  const canonicalUrl = useCompanyCanonicalUrl();
  const { data: company, status } = useCompany(canonicalUrl);

  useEffect(() => {
    if (isLogged.current || status !== 'success') {
      return;
    }
    isLogged.current = true;
    logCustomEvent('limit_modal_viewed', {
      companyName: company.data.name,
      companyTicker: company.data.unique_symbol,
    });
  }, [company?.data.name, company?.data.unique_symbol]);

  return null;
};
